import { RoutalPalette, RoutalSelect } from '@nx-smartmonkey/ui';
import React, { useState } from 'react';

import { CreateStopsManuallyDialog } from '../../dialogs/create-stops-manually/CreateStopsManuallyDialog';
import { DataImporter } from '../../dialogs/stops-data-importer';
import { PlanFlat } from '../../domain/plan/PlanFlat';
import { Stop } from '../../domain/stop/Stop';
import { ButtonProps } from '../../react-components/Button';
import Text from '../../react-components/Text';

type StopsCreateMenuProps = {
  id: string;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  hideSeparator?: boolean;
  intlId?: string;
  intlValues?: Record<string, string | number | ((chunks: any) => React.ReactElement)>;
  planStops?: Stop[];
  activePlan?: PlanFlat;
  onStopsCreated?: () => void;
};

export const StopsCreateMenu = ({
  id,
  style,
  containerStyle,
  hideSeparator,
  intlId,
  intlValues,
  planStops,
  activePlan,
  onStopsCreated,
}: StopsCreateMenuProps) => {
  const [dialog, setDialog] = useState<`createManually` | `stopsFromFile` | undefined>(undefined);

  return (
    <>
      <RoutalSelect
        id={id}
        style={style}
        hideSeparator={hideSeparator}
        containerStyle={containerStyle}
        arrowStyle={{
          color: RoutalPalette.oldWhite,
        }}
        popoverProps={{
          options: [
            {
              key: `create_manually`,
              onClick: () => setDialog(`createManually`),
              content: <Text intlId="plans.plan.stops.create_stops_manually" style={{ cursor: `pointer` }} />,
            },
            {
              key: `upload_excel`,
              onClick: () => setDialog(`stopsFromFile`),
              content: <Text intlId="plans.upload_excel" style={{ cursor: `pointer` }} />,
            },
          ],
        }}
      >
        <Text
          intlId={intlId ?? `planner.plan_details.stops_list.add_new`}
          intlValues={intlValues}
          style={{ color: RoutalPalette.oldWhite, cursor: `pointer` }}
        />
      </RoutalSelect>

      <CreateStopsManuallyDialog
        open={Boolean(dialog === `createManually`)}
        planId={activePlan?.id}
        planStops={planStops}
        handleCloseDialog={(e: React.MouseEvent<ButtonProps, MouseEvent>) => {
          e.stopPropagation();
          setDialog(undefined);
        }}
      />

      <DataImporter
        open={Boolean(dialog === `stopsFromFile`)}
        activePlan={activePlan}
        handleCloseDialog={(e: any) => {
          if (e) e.stopPropagation();
          setDialog(undefined);
        }}
        onComplete={() => {
          setDialog(undefined);
          onStopsCreated?.();
        }}
      />
    </>
  );
};
